import React from 'react';
import { connect } from 'unistore/react';
import isEmpty from 'lodash/fp/isEmpty';

import { TranslatedMessage } from 'common/components/Intl';

import {
  actions,
  selectedPodProps,
} from 'apps/build_your_plan/store/PlanStore';
import { Icon } from 'common/components/Icon';
import PodReviewLineItem from './PodReviewLineItem';
import AddOnReviewLineItem from './AddOnReviewLineItem';
import ReviewLedger from './ReviewLedger';
import { bool, func, objectOf } from 'prop-types';

export const Review = ({
  checkout,
  navigateTo,
  selectedAddOns,
  selectedPods,
  strikethroughPrices,
}) => {
  if (isEmpty(selectedPods)) {
    navigateTo('pods');
  }

  return (
    <div className="build-your-plan-review__wrapper">
      <h1 className="build-your-plan-review__title natural-heading--small">
        <TranslatedMessage id="your_order" />
      </h1>

      <div className="build-your-plan-review">
        <div className="build-your-plan-review__items">
          <div className="build-your-plan-review__items-header">
            <h2 className="natural-heading build-your-plan-review__items-heading build-your-plan-review__items-heading--color-auto-ship">
              <TranslatedMessage id="your_subscription" />
            </h2>

            <button
              className="build-your-plan-review__edit-items"
              onClick={() => navigateTo('pods')}
            >
              <TranslatedMessage
                className="text--button build-your-plan-review__edit-items-text"
                id="edit"
              />
              <Icon name="edit-outlined" />
            </button>
          </div>

          <p className="build-your-plan-review__schedule">
            <TranslatedMessage
              className="subheading--mini"
              id="your_delivery_schedule"
            />
            <br />
            <TranslatedMessage id="plan_builder.review.delivery_frequency" />
          </p>

          {Object.values(selectedPods).map(pod => {
            return <PodReviewLineItem key={pod.sku} pod={pod} />;
          })}

          {!isEmpty(selectedAddOns) && (
            <>
              <div className="build-your-plan-review__items-header build-your-plan-review__items-header--with-margin">
                <h2 className="natural-heading build-your-plan-review__items-heading">
                  <TranslatedMessage id="plan_builder.review.one_time_purchase" />
                </h2>

                <button
                  className="build-your-plan-review__edit-items"
                  onClick={() => navigateTo('add-ons')}
                >
                  <TranslatedMessage
                    className="text--button build-your-plan-review__edit-items-text"
                    id="edit"
                  />
                  <Icon name="edit-outlined" />
                </button>
              </div>

              {Object.values(selectedAddOns).map(addOn => {
                return (
                  <AddOnReviewLineItem
                    key={addOn.offering.id}
                    addOn={addOn}
                    strikethroughPrices={strikethroughPrices}
                  />
                );
              })}
            </>
          )}
        </div>

        <ReviewLedger checkout={checkout} />
      </div>
    </div>
  );
};

Review.propTypes = {
  checkout: func.isRequired,
  navigateTo: func.isRequired,
  selectedPods: objectOf(selectedPodProps),
  strikethroughPrices: bool.isRequired,
};

const ConnectedReview = connect(
  ['selectedAddOns', 'selectedPods', 'strikethroughPrices'],
  actions
)(Review);

ConnectedReview.displayName = 'ConnectedReview';

export default ConnectedReview;
